import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Panel from '../../../components/Panel';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody, Badge, ButtonGroup} from 'reactstrap';
import * as http from '../../../modules/http';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Modal from './Modal';
import * as TextManager from "../../../modules/languages/TextManager";
import OrderManage from './OrderManage'
import {postToServer} from "../../../modules/http";
import {withStyles} from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import arrayToCsv from "../../../modules/arrayToCsv";

import {orders_open_update_form} from '../../../redux/actions/OrdersActions'


const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const {classes, count, page, rowsPerPage, theme} = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {withTheme: true})(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class OrdersTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            deals: [],
            selectedID: '0',
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 10
        };
    }

    componentDidMount() {
        //window.setInterval(this.refreshPage, 5000);
    }

    editCustomer = (order) => {
        if (order.id === this.state.selectedID) {
            this.setState({selectedID: 0});
        }
        else {
            this.props.dispatch(orders_open_update_form(order));
            this.setState({selectedID: order.id});
        }
    };

    getRow(order, index) {

        let zeroNum = 0;
        let status = '';
        let color = '';

        for(let indx in order.orders) {
            if(order.orders[indx].simNums === '0' || order.orders[indx].simNums === 0) {
                zeroNum++;
            }
        }

        if(zeroNum === 0) {
            status = TextManager.getCurrentTextResource().Text.active;
            color = 'success';
        }
        else if(zeroNum === order.orders.length) {
            status = TextManager.getCurrentTextResource().Text.new;
            color = 'warning';
        }
        else {
            status = TextManager.getCurrentTextResource().Text.maintenance;
            color = 'primary';
        }

        return (

            <React.Fragment key={order.id}>

                <tr key={order.id} style={{cursor: 'pointer'}} onClick={() => this.editCustomer(order)}>

                    <td>
                        <Badge color={color}>{status}</Badge>
                    </td>
                    <td>{order.storeName}</td>
                    <td>{order.updateDay}</td>
                    <td>{order.day}</td>

                </tr>

                {order.id === this.state.selectedID &&
                <tr key={order.id + 2000}>
                    <td colSpan="12" style={{backgroundColor: 'aliceblue'}}>
                        <OrderManage order={order} onClose={() => {
                            this.setState({selectedID: 0});
                        }}/>
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };



    handleDownload = () => {
        let dataTmp = this.props.data;
        let data = [];

        if (dataTmp.length > 0) {
            let filterNames = Object.getOwnPropertyNames(dataTmp[0]);
            if (filterNames.includes('orders')) {
                for (let indx in dataTmp) {
                    for (let indx2 in dataTmp[indx].orders) {

                        let obj = {...dataTmp[indx]};

                        let providerName = this.props.providers.find(e => e.id === dataTmp[indx].orders[indx2].provider);
                        obj.orders = providerName.name + ": " + dataTmp[indx].orders[indx2].simNums;
                        //obj.simNums = dataTmp[indx].orders[indx2].simNums;

                        data.push(obj);
                    }
                }
            }
            else {
                data = dataTmp;
            }

            //console.log(data)

            /*let fileDownload = require('js-file-download');
            fileDownload(arrayToCsv({dataTmp, translated: TextManager.getCurrentTextResource().Customers}), 'download.csv');*/

            let csvContent = arrayToCsv({data, translated: TextManager.getCurrentTextResource().Customers});

            let link = window.document.createElement("a");
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
            link.setAttribute("download", "download.csv");
            link.click();
        }
    };

    render() {

        const {rowsPerPage, page} = this.state;

        let rows = this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((customer, index) =>
            this.getRow(customer, index)
        );

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>
                    <CardBody>
                        <span>
                            <Table responsive className='table-hover table--bordered'>
                                <thead>
                                <tr>
                                    <th>{TextManager.getCurrentTextResource().Customers.status}</th>
                                    <th>{TextManager.getCurrentTextResource().Orders.storeName}</th>
                                    <th>{TextManager.getCurrentTextResource().Orders.updateDay}</th>
                                    <th>{TextManager.getCurrentTextResource().Orders.day}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {rows}
                                </tbody>
                            </Table>
                            <Row>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <CustomPagination
                                        labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                        rowsPerPageOptions={[5, 10, 20]}
                                        component="div"
                                        count={this.props.data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </Col>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <ButtonGroup className='btn-group--icons'
                                                 style={{marginTop: "10px", float: "right"}}>
                                        <Button outline color='primary'
                                                onClick={this.handleDownload}>{TextManager.getCurrentTextResource().Utils.download}</Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </span>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.orders.status,
        data: state.orders.data,
        userData: state.userData,
        providers: state.sales.data,
    };
};

export default withRouter(connect(mapStateToProps)(OrdersTable))